import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { Body } from "../../theme/theme";
import { useParams, useHistory, useLocation } from "react-router-dom";
import config, { path, domain } from "../../config/enviroment";
import { shouldShowMarcaBlancaModal } from "../../components/MarcaBlancaModal/shouldShow";
import useView from "../../hooks/useView";
import { useForm } from "react-hook-form";
import {
	LoadContainer,
	CartContainer,
	CartSection,
	CartBody,
	SummaryDetailList,
	EmptyCart,
	CartProductsContainer,
	CartProductsWithNotice,
	ShareCart,
	TitleSummaryCart,
	ReturnLinkContainer,
} from "./style";
import Spinner from "../../components/Spinner";
import MainButton from "../../components/MainButton";
import "./style.css";
import { SummaryProductList } from "../../components/SummaryProductList";
import {
	handleRemoveProduct,
	handleIdentifyShoppingCart,
	updateTax,
	handleUpdateCart,
} from "../../redux/actions/shoppingCartActions";
import {
	handleGetAddress,
	handleGetCities,
	handleLoadShipping,
	handleGetCountries,
	handleResetDetails,
	setRoute,
	callDataConfingClientOwner,
	handleResetAveonlineQuotation,
} from "../../redux/actions";
import loadCheckout from "../../utils/loadCheckout.js";
import { AddMoreProducts } from "../../components/CartTotalSummary";
import CartTotalSummaryOne from "../../components/CartTotalSummary/Steps/one";
import CartTotalSummaryTwo from "../../components/CartTotalSummary/Steps/two";
import CartTotalSummaryThree from "../../components/CartTotalSummary/Steps/three";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AnddressInfo from "./AnddressInfo";
import ShippingInfo from "./ShippingInfo";
import { CartPaymentButton } from "../../components/CartTotalSummary/style";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Stepper, Step, StepLabel, StepIcon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { breakPoints } from "../../theme/theme";
import CartSummaryDetailBanner from "./CartSummaryDetailBanner";
import { language } from "../../utils/language";
import { isFreeShippingCoupon } from "../../utils/discountTypes";
import { viewTotalDiscountAmount } from "../../utils/formatData";
import {
	qualifiesForFreeShippingByMinPurchase,
	getFreeShippingStatus,
} from "../../utils/shippingRules";
import { getCartSubtotal, getPhysicalCartSubtotal } from "../../utils/cartSubtotal";
import { getCartReturnPath } from "../../utils/cartReturnPath";
import AddressInfoAveonline from "./AddressInfoAveonline";
import MarcaBlancaAddressInfo from "../../components/MarcaBlancaAddressInfo";
import FreeShippingProgress from "../../components/FreeShippingProgress";
import FreeShippingMinBanner from "../../components/FreeShippingMinBanner";

const normalizeText = (value: any) =>
	typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "";

const buildAveonlineAddress = ({
	streetType,
	streetName,
	streetNumber,
	crossNumber,
	housingType,
	locationDetail,
	departament,
	city,
	additionalAddress,
}: any) => {
	const street = [normalizeText(streetType), normalizeText(streetName)]
		.filter(Boolean)
		.join(" ");
	const number = [normalizeText(streetNumber), normalizeText(crossNumber)]
		.filter(Boolean)
		.join("-");
	const mainAddress = [street, number ? `# ${number}` : ""]
		.filter(Boolean)
		.join(" ");
	const residenceInfo = [normalizeText(housingType), normalizeText(locationDetail)]
		.filter(Boolean)
		.join(" ");
	const cityInfo = [normalizeText(departament), normalizeText(city)]
		.filter(Boolean)
		.join(" ");
	const extraInfo = normalizeText(additionalAddress);
	let address = [mainAddress, residenceInfo].filter(Boolean).join(" ");

	if (cityInfo) {
		address = `${address}. ${cityInfo}`.trim();
	}
	if (extraInfo) {
		address = `${address} ${extraInfo}`.trim();
	}
	return address.replace(/\s+\./g, ".").replace(/\s+/g, " ").trim();
};

const CartSummary = () => {
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const shippingDetailsState: any = useSelector(
		(state: RootState) => state.shippingDetails
	);
	const categoryState: any = useSelector((state: RootState) => state.category);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const [loadScript, setLoadScript] = useState(true);
	const shoppingCartState: ShoppingCartStateType = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const countryState: any = useSelector((state: RootState) => state.country);
	const dispatch = useDispatch();
	const { idCart, idCatalog }: any = useParams();
	const { display } = useView();
	const history = useHistory();
	const location = useLocation();
	const {
		formState,
		getValues,
		register,
		handleSubmit,
		errors,
		trigger,
		setValue,
	} = useForm();
	const [loadClient, setLoadClient] = useState(false);
	const [emailClient, setEmailClient] = useState("");
	const [activeStep, setActiveStep] = useState(0);
	const [cityName, setCityName] = useState("");
	const [countryName, setCountryName] = useState("Colombia");
	const termsAndConditions: {
		terms: boolean;
		conditions: boolean;
		saveInfoShipping: boolean;
	} = useSelector((state: RootState) => state.termsConditions);
	const [appliedCoupons, setAppliedCoupons] = useState<Coupon[]>([]);
	const { width } = useView();
	const [showDetailOnMobile, setShowDetailOnMobile] = useState(false);
	const [items, setItems] = useState<any>([]);
	const [subTotalAmount, setSubTotalAmount] = useState(0);
	const aveonlineIntegration: any = useSelector((state: RootState) => state.aveonline.integration);
	const [productsAveonline, setProductsAveonline] = useState<boolean>(false);
	const [selectedOperator, setOperator] = useState<any>(null);
	const [buyerIsAveonline, setBuyerIsAveonline] = useState(false);
	const [allProductsDigital, setAllProductsDigital] = useState(false);
	const [hasPhysicalProducts, setHasPhysicalProducts] = useState(true);

	useEffect(() => {
		const productsRefs = shoppingCartState.cartInfo.filter(
			(item: any) => item.references && item.references.length > 0
		);
		const productsData = shoppingCartState.cartInfo.filter(
			(item: any) => !(item.references && item.references.length > 0)
		);
		if (productsRefs.length > 0) {
			productsRefs.map((product: any) => {
				product.references.map((itemRef: any) => {
					itemRef.data = product.productData.references.find(
						(field: any) => field.id === itemRef.id
					);
					productsData.push({ ...product, references: [itemRef] });
				});
			});
		}
		setItems(productsData);
		const hasAveonlineProduct = shoppingCartState.cartInfo.some((item: any) => item.productData.aveonlineId);
		setProductsAveonline(hasAveonlineProduct);
		const cartInfo = shoppingCartState.cartInfo;

		const isDigital = (item: any) => item.productData?.type === 'digital' || item.productData?.typeProduct === 'digital';
		setAllProductsDigital(cartInfo.length > 0 && cartInfo.every(isDigital));
		setHasPhysicalProducts(cartInfo.some((item: any) => !isDigital(item)));
	}, [shoppingCartState.cartInfo]);

	useEffect(() => {
		const subTotal = getCartSubtotal(items);

		if (subTotal) {
			setSubTotalAmount(subTotal);
		}

	}, [items]);

	useEffect(() => {
		if (activeStep !== 2) return;
		dispatch(
			handleLoadShipping({
				discountCodes: appliedCoupons.filter((item: Coupon) => !item.error),
			})
		);
	}, [activeStep, appliedCoupons]);

	// auto-scroll
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [activeStep]);

	useEffect(() => {
		if (!isAveonlineIntegration() && shippingDetailsState.isAveonline === true) {
			setBuyerIsAveonline(true);
		} else {
			setBuyerIsAveonline(false);
		}
	}, [shippingDetailsState.isAveonline]);

	useEffect(() => {
		dispatch(handleResetDetails());
		setEmailClient("");
		setLoadClient(false);
		setBuyerIsAveonline(false);
		dispatch(handleGetAddress(path));
		dispatch(handleGetCities(path));
		dispatch(handleGetCountries(path));
		dispatch(
			setRoute({
				route: "/",
				routeName: language[homeState.default_language]["shoppingCart"],
			})
		);
	}, [dispatch]);

	useEffect(() => {
		const search = location.search || "";
		if (shoppingCartState.id !== 0 || idCart !== 0) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/${idCart}${search}`
			);
		} else if (shoppingCartState.id === 0 && idCart.toStrign().length > 1) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/empty${search}`
			);
		}
		loadCheckout(() => {
			setLoadScript(false);
		});
	}, [homeState.catalogueName, idCart, location.search, shoppingCartState.id]);

	const mappingItems = () => {
		const productsRefs = shoppingCartState.cartInfo.filter(
			(item: any) => item.references && item.references.length > 0
		);
		const productsData = shoppingCartState.cartInfo.filter(
			(item: any) => !(item.references && item.references.length > 0)
		);
		if (productsRefs.length > 0) {
			productsRefs.map((product: any) => {
				product.references.map((itemRef: any) => {
					itemRef.data = product.productData.references.find(
						(field: any) => field.id === itemRef.id
					);
					productsData.push({ ...product, references: [itemRef] });
				});
			});
		}
		return productsData;
	};

	const calculateTax = (product: any, field: string) => {
		if (!(product.references && product.references.length)) {
			return (
				product.productData[
					field === "tax" ? "taxAmount" : "consumptionTaxAmount"
				] * product.quantity
			);
		} else {
			let price =
				product.references[0].data.netAmount !== 0 &&
				product.references[0].data.discountPrice !== 0
					? product.references[0].data.discountPrice
					: product.references[0].data.amount;
			return (
				((price * product.references[0].data[field]) / 100) *
				product.references[0].quantity
			);
		}
	};

	const calculateTaxes = () => {
		const items = mappingItems();
		let taxAmount = 0;
		let consumptionTaxAmount = 0;
		if (items.length > 0) {
			for (let i = 0; i < items.length; i++) {
				const product = items[i];
				taxAmount += calculateTax(product, "tax");
				consumptionTaxAmount += calculateTax(product, "consumptionTax");
			}
		}
		dispatch(updateTax(taxAmount, consumptionTaxAmount));
	};

	useEffect(() => {
		calculateTaxes();
	}, [shoppingCartState.cartInfo]);

	useEffect(() => {
		dispatch(callDataConfingClientOwner(path));
		if (shoppingCartState.id !== idCart && idCart !== 0 && idCart !== "empty") {
			dispatch(
				handleIdentifyShoppingCart(
					idCart,
					`${domain}/vende/${homeState.catalogueUrlName}`,
					window.location,
					[],
					homeState.default_language
				)
			);
		} else {
			setActiveStep(0)
		}
	}, [homeState.catalogueName, idCart]);

	const removeProduct = (
		position: number,
		lastProduct: boolean = false,
		idRef: any = "",
		productId: number
	) => {
		dispatch(
			handleRemoveProduct(
				productId,
				shoppingCartState.id,
				path,
				idRef,
				homeState.default_language,
				lastProduct,
				homeState.catalogueName,
				history
			)
		);
	};

	const handleNextStep = () => {
		if (activeStep === 0) {
			
			shoppingCartState.cartInfo.forEach((value:any)=>{

				if(value.references && value.references.length>0)
				{
					//WE VERIFY IF THE PRODUCT HAS REFERENCES

				
					value.references.forEach((ref:any)=>{

						ref.finalQuantity = Math.abs(parseInt(ref.quantity)-parseInt(ref.initialQuantity));
						ref.action = (ref.quantity>ref.initialQuantity) ? "substract":"add";

					});

				}else{

					
					//OTHERWISE
					value.finalQuantity = Math.abs(parseInt(value.quantity)-parseInt(value.initialQuantity));
					value.action = (value.quantity>value.initialQuantity) ? "substract":"add";
				
				}
			});


			setAppliedCoupons(shippingDetailsState.discountCodes);
			if (shoppingCartState.update) {

				dispatch(
					handleUpdateCart(
					  shoppingCartState.cartInfo,
					  shoppingCartState.id,
					  path,
					  homeState.default_language
					)
				  )
			}
			setEmailClient(shippingDetailsState.email);
		}
		if (activeStep === 1) {
			const values = getValues();
			const isAveonline = isAveonlineIntegration() || buyerIsAveonline;
			const itemsCountry = countryState.countries.find(
				(itemContry: any) => itemContry.name === values.country
			);

			const data: any = {
				firstName: values.name !== "" ? values.name : undefined,
				lastName: values.lastname !== "" ? values.lastname : undefined,
				documentId: values.document !== "" ? values.document : undefined,
				documentType: values.documentType !== "" ? values.documentType : undefined,
				email: emailClient,
				phone: values.phone,
				address1: values.address !== "" ? values.address : undefined,
				address2: values.optional1 !== "" ? values.optional1 : undefined,
				city: cityName,
				codeDane: values.city && values.city !== "" ? values.city : undefined,
				departament:
					values.departament && values.departament !== ""
						? values.departament
						: undefined,
				country:
					values.country && values.country !== "" ? values.country : undefined,
				saveInfoClient: termsAndConditions.saveInfoShipping,
				countryName:
					countryName !== ""
						? countryName
						: itemsCountry
						? itemsCountry.title
						: "Colombia",
				infoCompleted: true,
				countryCode: itemsCountry?.id,
				discountCodes: appliedCoupons.filter((item: Coupon) => !item.error),
				isAveonline: false,
			};

			if (isAveonline) {
				data.streetType = values.streetType;
				data.streetName = values.streetName;
				data.streetNumber = values.streetNumber;
				data.crossNumber = values.crossNumber;
				data.housingType = values.housingType;
				data.locationDetail = values.locationDetail;
				data.additionalAddress = values.additionalAddress || "";
				data.address1 = buildAveonlineAddress({
					streetType: values.streetType,
					streetName: values.streetName,
					streetNumber: values.streetNumber,
					crossNumber: values.crossNumber,
					housingType: values.housingType,
					locationDetail: values.locationDetail,
					departament: values.departament,
					city: cityName,
					additionalAddress: values.additionalAddress,
				});
				data.address2 = values.additionalAddress || "";
				data.codeDane = values.cityDane || undefined;
				data.documentId = values.documentNumber || undefined;
				data.isAveonline = true;
				data.departamentoAveonline = values.departament;
				data.municipioAveonline = cityName;
				data.documentNumber = values.documentNumber || undefined;
				data.country = "CO";
				data.countryName = "Colombia";
				data.carrier = {
					deliveryAmount: selectedOperator?.value,
					id: Number(selectedOperator?.idCarrier),
					nameCarrier: selectedOperator?.nameCarrier,
					daysDelivery: selectedOperator?.dateDelivery,
				};
			}

			if (isMarcaBlancaStore) {
				data.firstName = marcaBlancaState.client?.firstName;
				data.lastName = marcaBlancaState.client?.lastName;
				data.documentId = marcaBlancaState.documentNumber;
				data.documentType =
					marcaBlancaState.documentTypeCode || marcaBlancaState.documentTypeId;
				data.email = marcaBlancaState.client?.email;
				data.phone = marcaBlancaState.client?.mobile;
				data.address1 = marcaBlancaState.branch?.formatted;
				data.address2 = marcaBlancaState.branch?.addressDetail || "";
				data.departament = marcaBlancaState.branch?.regionName;
				data.city = marcaBlancaState.branch?.cityName;
				data.codeDane = marcaBlancaState.branch?.cityDaneCode;
				data.country = "CO";
				data.countryName = "Colombia";
				data.branchId = marcaBlancaState.branch?.id;
				data.sellerCode = marcaBlancaState.sellerCode || undefined;
			}

			dispatch(handleLoadShipping(data));
		}
		setActiveStep((prevStep) => prevStep + 1);
	};

	const handlePreviousStep = () => {
		if (activeStep === 2) {
			dispatch(handleResetAveonlineQuotation());
			setOperator(null);
		}
		if (activeStep === 1) {
			setBuyerIsAveonline(false);
		}
		setActiveStep((prevStep) => prevStep - 1);
	};

	const steps = [
		{
			label: `${language[homeState.default_language]["cart"]}`,
			status: activeStep > 0 ? "completed" : "active",
			icon: <CheckCircleIcon />,
		},
		{
			label: `${language[homeState.default_language]["infoCart"]}`,
			status:
				activeStep === 1 ? "active" : activeStep > 1 ? "completed" : "pending",
			icon: <CheckCircleIcon />,
		},
		{
			label: `${language[homeState.default_language]["send"]}`,
			status:
				activeStep === 2 ? "active" : activeStep > 2 ? "completed" : "pending",
			icon: <CheckCircleIcon />,
		},
		{
			label: `${language[homeState.default_language]["paymentCart"]}`,
			status:
				activeStep === 3 ? "active" : activeStep > 3 ? "completed" : "pending",
			icon: <CheckCircleIcon />,
		},
	];

	interface ShoppingCartProps {
		color: string;
	}
	const isAveonlineIntegration = ()=>{
		if(aveonlineIntegration?.status && productsAveonline && aveonlineIntegration?.wherehouseStatus == 'Confirmado'){
			return true;
		}
		return false;
	}

	// Aveonline flow is active when the merchant has the integration enabled OR
	// the buyer's stored address came from an Aveonline checkout (buyerIsAveonline).
	const isAveonlineFlow = isAveonlineIntegration() || buyerIsAveonline;
	const clientState: any = useSelector((state: RootState) => state.client);
	const marcaBlancaState: any = useSelector(
		(state: RootState) => state.marcaBlanca
	);
	const isMarcaBlancaStore = shouldShowMarcaBlancaModal(
		clientState?.id,
		config.marcaBlancaId
	);
	const discountCodeAmount = Number(
		viewTotalDiscountAmount(
			items,
			appliedCoupons.filter((coupon: Coupon) => !coupon.error),
			subTotalAmount +
				shoppingCartState.taxAmountTotal +
				shoppingCartState.consumptionTaxAmountTotal,
			"amount",
			"COP",
			homeState.default_language
		)
	) || 0;
	// VEN-4007: envio gratis cuando el subtotal menos descuentos alcanza el
	// minimo configurado. Aveonline cotiza con el operador y queda fuera.
	const physicalSubTotalAmount = getPhysicalCartSubtotal(shoppingCartState.cartInfo);
	const freeShippingByMinPurchase =
		!isAveonlineFlow &&
		qualifiesForFreeShippingByMinPurchase(
			homeState.shippingType,
			homeState.freeShippingMinAmount,
			physicalSubTotalAmount,
			discountCodeAmount
		);
	const freeShippingStatus = getFreeShippingStatus(
		homeState.shippingType,
		homeState.freeShippingMinAmount,
		physicalSubTotalAmount - discountCodeAmount
	);
	const showFreeShippingNotice =
		!isAveonlineFlow && !allProductsDigital && freeShippingStatus.applies;
	const baseShippingCost = (!isAveonlineIntegration() && !isMarcaBlancaStore && allProductsDigital)
		? 0
		: shoppingCartState.shippingCost;
	const effectiveShippingCost = freeShippingByMinPurchase ? 0 : baseShippingCost;
	const ShoppingCart = ({ color }: ShoppingCartProps) => {
		return (
			<div className={"shopping-cart-container"}>
				<div className={"container-title"}>
					<TitleSummaryCart
						color={homeState.color}
						isEmpty={shoppingCartState.cartInfo.length <= 0}
					>
						<span>{language[homeState.default_language]["shoppingCart"]}</span>
					</TitleSummaryCart>
					{display !== "desktop" && shoppingCartState.cartInfo.length > 0 && (
						<ShareCart
							url={`${domain}/vende/${homeState.catalogueUrlName}/carrito/${shoppingCartState.id}`}
							color={homeState.color}
							outlined={true}
						/>
					)}
				</div>
				{shoppingCartState.cartInfo.length <= 0 ||
				shoppingCartState.cartState === "pagado" ? (
					<EmptyCart>
						<div>
							<svg
								data-src={`${config.urlMultimedia}/vende/landing-img/CartIcon.svg`}
							/>
						</div>
						<div>{language[homeState.default_language]["empatyCart"]}</div>
						<MainButton
							color={homeState.color}
							onClick={() =>
								history.push(`/vende/${homeState.catalogueUrlName}/categories`)
							}
						>
							{language[homeState.default_language]["addProduct"]}
						</MainButton>
					</EmptyCart>
				) : showFreeShippingNotice ? (
					<CartProductsWithNotice>
						<CartProductsContainer>
							<SummaryProductList
								data={shoppingCartState.cartInfo}
								color={homeState.color}
								loading={shoppingCartState.loading}
								onDelete={removeProduct}
								history={history}
								catalogueName={homeState.catalogueName}
								categoryList={categoryState.listCategory}
							/>
						</CartProductsContainer>
						<FreeShippingProgress
							variant="cartStep1"
							status={freeShippingStatus}
							color={homeState.color}
							onKeepShopping={() => history.push(`/vende/${idCatalog}/`)}
						/>
					</CartProductsWithNotice>
				) : (
					<CartProductsContainer>
						<SummaryProductList
							data={shoppingCartState.cartInfo}
							color={homeState.color}
							loading={shoppingCartState.loading}
							onDelete={removeProduct}
							history={history}
							catalogueName={homeState.catalogueName}
							categoryList={categoryState.listCategory}
						/>
					</CartProductsContainer>
				)}

				<div className="shipping-info_footer-buttons">
					<ReturnLinkContainer
						style={{ color: `${homeState.color}` }}
						className="return-link-container"
					>
						<a
							style={{
								cursor: "pointer",
								color: `${homeState.color} !important`,
							}}
							onClick={() => {
								const from = (location.state as any)?.from || getCartReturnPath();
								history.push(from || `/vende/${homeState.catalogueUrlName}`);
							}}
							className="return-link"
						>
							<ChevronLeftIcon style={{ color: `${homeState.color}` }} />{" "}
							{language[homeState.default_language]["back"]}
						</a>
					</ReturnLinkContainer>

					<div className="shipping-info__pay-button-container">
						<CartPaymentButton
							color={color}
							loading={shoppingCartState.loading}
							onClick={handleNextStep}
							disabled={shoppingCartState.loading || shoppingCartState.cartInfo.length <= 0}
						>
							{language[homeState.default_language]["continue"]}
						</CartPaymentButton>
						<AddMoreProducts
							language={language[homeState.default_language]["addMoreProducts"]}
							onClick={() =>
								history.push(`/vende/${homeState.catalogueUrlName}/categories`)
							}
						/>
					</div>
				</div>
			</div>
		);
	};

	const findQuote = (operator: string) => {
		const quotes = elogisticaState.requestQuote.filter(
			(quote: any) => quote.operador === operator
		);
		if (quotes.length > 1) {
			let min = quotes[0].valor;
			let key = 0;
			for (let i = 1; i < quotes.length; i++) {
				if (quotes[i].valor < min) {
					min = quotes[i].valor;
					key = i;
				}
			}
			return quotes[key];
		}
		return quotes && quotes.length > 0 ? quotes[0] : null;
	};

	const useStyles = makeStyles({
		activeStepIcon: {
			"& .MuiStepIcon-root.MuiStepIcon-active": {
				color: homeState.color,
			},
		},
		completedStepIcon: {
			"& .MuiStepIcon-root.MuiStepIcon-completed": {
				color: homeState.color,
			},
		},
	});

	const classes = useStyles({ color: homeState.color });

	const handleShowDetailOnMobile = () => {
		setShowDetailOnMobile(!showDetailOnMobile);
	};

	const isMobile = width <= 992;

	return (
		<Body padding="0px">
			{shoppingCartState.loading ||
			shoppingCartState.inSummaryPage ||
			loadScript ? (
				<LoadContainer>
					<Spinner color={homeState.color} />
				</LoadContainer>
			) : (
				<>
					{activeStep === 0 && <FreeShippingMinBanner />}
					<CartBody>
						<CartSection>
							{((activeStep === 1 && isMobile) ||
								(activeStep === 2 && isMobile)) && (
								<CartSummaryDetailBanner
									color={homeState.color}
									totalAmount={shoppingCartState.totalAmount}
									showDetailOnMobile={showDetailOnMobile}
									handleShowDetailOnMobile={handleShowDetailOnMobile}
								/>
							)}
							<div className="parentContainer">
								<CartSection>
									<div
										className={`childContainer ${
											showDetailOnMobile ? "modal-active" : ""
										}`}
									>
										<CartContainer
											width={
												shoppingCartState.cartInfo.length <= 0 ? "60%" : "100%"
											}
										>
											<SummaryDetailList color={homeState.color}>
												<div className="stepper-container">
													<Stepper
														className={`${classes.activeStepIcon} ${classes.completedStepIcon} stepper-styles`}
														activeStep={activeStep}
														alternativeLabel
														style={{ color: homeState.color }}
													>
														{steps.map((step, index) => (
															<Step
																key={index}
																completed={step.status === "completed"}
																style={{ color: homeState.color }}
															>
																<StepLabel
																	className="stepper-styles__label"
																	StepIconComponent={
																		step.icon ? StepIcon : undefined
																	}
																>
																	{step.label}
																</StepLabel>
															</Step>
														))}
													</Stepper>
												</div>

												{activeStep === 0 && (
													<ShoppingCart color={homeState.color} />
												)}

												{activeStep === 1 && isMarcaBlancaStore && (
													<MarcaBlancaAddressInfo
														color={homeState.color}
														register={register}
														setValue={setValue}
														getFormValues={getValues}
														nextStep={handleNextStep}
														previousStep={handlePreviousStep}
														showModal={showDetailOnMobile}
														goToCart={() => setActiveStep(0)}
													/>
												)}
												{activeStep === 1 && !isMarcaBlancaStore && isAveonlineFlow && (
													<AddressInfoAveonline
														isValidForm={formState.isValid}
														getFormValues={getValues}
														register={register}
														handleSubmit={handleSubmit}
														errors={errors}
														trigger={trigger}
														loadClient={loadClient}
														emailClient={emailClient}
														setLoadClient={setLoadClient}
														setEmailClient={setEmailClient}
														color={homeState.color}
														nextStep={handleNextStep}
														previousStep={handlePreviousStep}
														successInfo={loadClient}
														setCityName={setCityName}
														setCountryName={setCountryName}
														catalogueId={shoppingCartState.catalogueId}
														setValue={setValue}
														showModal={showDetailOnMobile}
														isAveonlineIntegration={isAveonlineIntegration()}
													/>
												)}
												{activeStep === 1 && !isMarcaBlancaStore && !isAveonlineFlow && (
													<AnddressInfo
														isValidForm={formState.isValid}
														getFormValues={getValues}
														register={register}
														handleSubmit={handleSubmit}
														errors={errors}
														trigger={trigger}
														loadClient={loadClient}
														emailClient={emailClient}
														setLoadClient={setLoadClient}
														setEmailClient={setEmailClient}
														color={homeState.color}
														nextStep={handleNextStep}
														previousStep={handlePreviousStep}
														successInfo={loadClient}
														setCityName={setCityName}
														setCountryName={setCountryName}
														catalogueId={shoppingCartState.catalogueId}
														setValue={setValue}
														showModal={showDetailOnMobile}
													/>
												)}

												{activeStep === 2 && (
													<ShippingInfo
														loadClient={loadClient}
														emailClient={emailClient}
														setLoadClient={setLoadClient}
														setEmailClient={setEmailClient}
														previousStep={handlePreviousStep}
														findQuote={findQuote}
														subTotalAmount={subTotalAmount}
														taxAmountTotal={shoppingCartState.taxAmountTotal}
														consumptionTaxAmountTotal={
															shoppingCartState.consumptionTaxAmountTotal
														}
														showModal={showDetailOnMobile}
														shippingCost={effectiveShippingCost}
														baseShippingCost={baseShippingCost}
														isAveonline={isAveonlineFlow}
														getShippinOperator={setOperator}
														allProductsDigital={allProductsDigital}
														goToCart={() => setActiveStep(0)}
													/>
												)}
											</SummaryDetailList>
										</CartContainer>

										{shoppingCartState.cartInfo.length > 0 && (
											<>
												<AddMoreProducts
													showOnlyOnMobile
													language={
														language[homeState.default_language][
															"addMoreProducts"
														]
													}
													onClick={() =>
														history.push(
															`/vende/${homeState.catalogueUrlName}/categories`
														)
													}
												/>
											</>
										)}
									</div>
									{shoppingCartState.cartInfo.length > 0 && (
										<>
											{activeStep === 0 && (
												<CartTotalSummaryOne
													color={homeState.color}
													clientId={shoppingCartState.clientId}
													cartId={shoppingCartState.id}
													data={shoppingCartState.cartInfo}
													totalAmount={shoppingCartState.totalAmount}
													shippingAmount={shoppingCartState.customShippingValue}
													taxAmountTotal={shoppingCartState.taxAmountTotal}
													consumptionTaxAmountTotal={
														shoppingCartState.consumptionTaxAmountTotal
													}
													publicKey={shoppingCartState.publicKey}
													isValidForm={formState.isValid}
													getFormValues={getValues}
													nextStep={handleNextStep}
													activeStep={activeStep}
												/>
											)}
											{activeStep === 1 && (
												<CartTotalSummaryTwo
													color={homeState.color}
													clientId={shoppingCartState.clientId}
													cartId={shoppingCartState.id}
													catalogueId={shoppingCartState.catalogueId}
													data={shoppingCartState.cartInfo}
													totalAmount={shoppingCartState.totalAmount}
													shippingAmount={shoppingCartState.customShippingValue}
													taxAmountTotal={shoppingCartState.taxAmountTotal}
													consumptionTaxAmountTotal={
														shoppingCartState.consumptionTaxAmountTotal
													}
													publicKey={shoppingCartState.publicKey}
													isValidForm={formState.isValid}
													getFormValues={getValues}
													nextStep={handleNextStep}
													loading={shoppingCartState.loading}
													successInfo={loadClient}
													items={items}
													subTotalAmount={subTotalAmount}
													appliedCoupons={appliedCoupons}
													setAppliedCoupons={setAppliedCoupons}
													showDetailOnMobile={showDetailOnMobile}
													freeShippingReached={freeShippingByMinPurchase}
													freeShippingNotice={
														showFreeShippingNotice && (
															<FreeShippingProgress
																variant="summary"
																status={freeShippingStatus}
																color={homeState.color}
															/>
														)
													}
												/>
											)}

											{activeStep === 2 && (
												<CartTotalSummaryThree
													color={homeState.color}
													clientId={shoppingCartState.clientId}
													cartId={shoppingCartState.id}
													catalogueId={shoppingCartState.catalogueId}
													data={shoppingCartState.cartInfo}
													totalAmount={shoppingCartState.totalAmount}
													shippingAmount={
														appliedCoupons.some(isFreeShippingCoupon)
															? 0
															: isMarcaBlancaStore
															? (selectedOperator?.value ?? 0)
															: isAveonlineFlow
															? (allProductsDigital ? 0 : (selectedOperator?.value ?? 0))
															: effectiveShippingCost + (allProductsDigital ? 0 : shoppingCartState.customShippingValue)
													}
												carrier={(isMarcaBlancaStore || isAveonlineFlow) ? selectedOperator : null}
													taxAmountTotal={shoppingCartState.taxAmountTotal}
													consumptionTaxAmountTotal={
														shoppingCartState.consumptionTaxAmountTotal
													}
													publicKey={shoppingCartState.publicKey}
													isValidForm={formState.isValid}
													getFormValues={getValues}
													nextStep={handleNextStep}
													loading={shoppingCartState.loading}
													successInfo={loadClient}
													findQuote={findQuote}
													appliedCoupons={appliedCoupons}
													setAppliedCoupons={setAppliedCoupons}
													subTotalAmount={subTotalAmount}
													showDetailOnMobile={showDetailOnMobile}
													freeShippingNotice={
														showFreeShippingNotice && (
															<FreeShippingProgress
																variant="summary"
																status={freeShippingStatus}
																color={homeState.color}
															/>
														)
													}
												/>
											)}
										</>
									)}
								</CartSection>
							</div>
						</CartSection>
					</CartBody>
				</>
			)}
		</Body>
	);
};

export default CartSummary;
